import { useMemo } from 'react'

import { useZervantSettings } from '../../../../../hooks/useZervantSettings'
import { getComplianceSettingsDefaultValues } from '../utils/getComplianceSettingsDefaultValues'

export const usePredefinedComplianceSettingsFormValues = () => {
  const { data: zervantSettings, hasFailedToLoad, isLoading, refetch } = useZervantSettings()

  const predefinedComplianceSettingsFormValues = useMemo(
    () => getComplianceSettingsDefaultValues(zervantSettings?.values?.company),
    [zervantSettings?.values?.company],
  )

  return { hasFailedToLoad, isLoading, predefinedComplianceSettingsFormValues, refetch }
}
